module.exports = __webpack_public_path__ + "gift_card.png?ab8f4901803fe7e1187588bca8477550";


//////////////////
// WEBPACK FOOTER
// ./src/static/headers/gift_card.png
// module id = 881
// module chunks = 0